<template>
	<v-text-field
		v-bind="$attrs"
		@update:model-value="$emit('input', $event)"
	>
		<template #append-inner>
			<v-tooltip location="bottom">
				<template #activator="{ props }">
					<v-icon
						v-bind="props"
						icon="$infoOutline"
					/>
				</template>
				<span>{{ tooltipText }}</span>
			</v-tooltip>
		</template>
	</v-text-field>
</template>

<script>
/**
 * An extension of vuetify's text field that includes a tooltip to provide extra information
 */
export default {
	name: 'TooltipField',
	props: {
		tooltipText: {
			type: String,
			required: true,
		},
	},
	emits: ['input',],
};
</script>
